import urls from '../../urls';
import { route } from '../helpers';
import { HandOffPages, PointStages } from '../../constants/AppConstants';
import UserStore from '../../stores/UserStore';
import FareHandOffActions from '../../actions/FareHandOffActions';

export default route(HandOffPages.FARE, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/handoff/FareHandOff').default);
        }, 'handoff-fare');
    },

    async onEnter (nextState, replace, callback) {
        try {
            const user = UserStore.getCurrent();
            await FareHandOffActions.getReorderable(nextState.location.query, user);
        } catch (error) {
            console.error('Error getting favourites', error);
            replace(urls.location(PointStages.SEARCH));
        }

        callback();
    }
});
